import BaseRequest from './BaseRequest';
import HTTPRequest from '../HTTPRequest';

export default class CustomerMemberships extends BaseRequest {
    /**
     * CustomerMemberships constructor
     *
     * @param {string} requestMode
     * @param {string} providerId
     * @param {string} customerId
     * @param {boolean} auth
     * @param {boolean} fowardRequest
     */
    constructor(
        requestMode = 'customer',
        providerId = '',
        customerId = '',
        auth = true,
        fowardRequest = false,
    ) {
        super(requestMode, providerId, customerId, auth, fowardRequest);
        this.setClassName('CustomerMemberships');
        this.setEndpoint('customer_memberships');
    }

    /**
     * @param {string} membershipId
     * @param {string} customerId
     * @return {object}
     */
    async cancel(membershipId = '', customerId = '') {
        if (customerId == '') {
            customerId = this.getCustomerId();
        }

        let request = new HTTPRequest(
            'POST',
            `${this.getEndpoint()}/${membershipId}/cancel`,
            this.getHeaders(),
        );
        if (this.getForwardRequest()) {
            request = this.buildForwardRequest(this.getClassName(), 'cancel', {
                membershipId: membershipId,
                customerId: customerId,
            });
        }

        return await request.sendRequest();
    }

    /**
     * @param {string} membershipId
     * @param {string} customerId
     * @return {object}
     */
    async usage(membershipId = '', customerId = '') {
        if (customerId == '') {
            customerId = this.getCustomerId();
        }

        let request = new HTTPRequest(
            'GET',
            `${this.getEndpoint()}/${membershipId}/usage`,
            this.getHeaders(),
        );

        if (this.getForwardRequest()) {
            request = this.buildForwardRequest(this.getClassName(), 'usage', {
                membershipId: membershipId,
                customerId: customerId,
            });
        }

        return await request.sendRequest();
    }
}
